import { gatewayPageBuilder } from "../../../../gateways/gatewayPageBuilder";

export type DraftDto = {
    id: string;
    projectName: string;
    templateId: string;
    thumbnailUrl?: string | null;
    content: { html: string; css: string };
    documentHtml: string;
    patchVersion: number;
    meta: { externalUid: number | null;[k: string]: any };
    createdAt: string;
    updatedAt: string;
};

export const getDraftById = async (draftId: string): Promise<DraftDto> => {
    const token = sessionStorage.getItem("token");
    if (!token) throw new Error("No auth token found");

    const { data } = await gatewayPageBuilder.get<{ status: number; data: DraftDto }>(
        `page-builder/drafts/${draftId}`,
        {
            headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type": "application/json",
            },
        }
    );

    return data.data;
};
